export default {
  onboard: state => state.onboard,
  testMode: state => state.testMode,
  products: state => state.products,
  disable: state => state.disable
}



// WEBPACK FOOTER //
// ./src/store/modules/onboard/getters.js